module.exports = __webpack_public_path__ + "static/img/cj10.338799d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj10.png
// module id = 153
// module chunks = 0